module.exports = __webpack_public_path__ + "static/media/styledSchedule-cmf.5ecd8345.svg";